module.exports = __webpack_public_path__ + "img/basic_lotion_202311.d746b91e.jpg";